import { useState } from "react";

type CategoryMeta = {
  label: string;
  thumbBg: string;
  thumbFg: string;
  thumbLabel: string;
};

export function inferCategory(sku: string, category?: string | null): CategoryMeta {
  const cat = (category || "").toLowerCase();
  const first = (sku.split("-")[0] || "").toUpperCase();
  if (cat.startsWith("poke") || first === "POK")
    return { label: "Pokémon", thumbBg: "#FFE4D6", thumbFg: "#9A3412", thumbLabel: "POK" };
  if (cat.replace(/\s|_/g, "") === "onepiece" || first === "OP")
    return { label: "One Piece", thumbBg: "#DBEAFE", thumbFg: "#1E40AF", thumbLabel: "OP" };
  if (cat.startsWith("yugio") || cat.startsWith("yu-gi") || first === "YGO")
    return { label: "Yu-Gi-Oh!", thumbBg: "#FCE7F3", thumbFg: "#9D174D", thumbLabel: "YGO" };
  if (cat.startsWith("lorcana") || first === "LOR")
    return { label: "Lorcana", thumbBg: "#FFEDD5", thumbFg: "#C2410C", thumbLabel: "LOR" };
  if (cat.startsWith("funko") || first === "FUN")
    return { label: "Funko", thumbBg: "#CCFBF1", thumbFg: "#0F766E", thumbLabel: "FUN" };
  if (cat.includes("dragon") || first === "DB")
    return { label: "Dragon Ball", thumbBg: "#FEF3C7", thumbFg: "#92400E", thumbLabel: "DB" };
  if (cat.includes("magic") || first === "MTG")
    return { label: "Magic", thumbBg: "#E6EBF8", thumbFg: "#1B3A8C", thumbLabel: "MTG" };
  return { label: "Altro", thumbBg: "#F4F1EA", thumbFg: "#3E4255", thumbLabel: first.slice(0, 3) || "???" };
}

const SIZES = { xs: 32, sm: 40, md: 52, lg: 96 } as const;

export function ProductThumb({
  imageUrl,
  sku,
  category,
  size = "sm",
  warnNoShopify,
  radius,
}: {
  imageUrl: string | null | undefined;
  sku: string;
  category?: string | null;
  size?: keyof typeof SIZES;
  warnNoShopify?: boolean;
  radius?: number;
}) {
  const [errored, setErrored] = useState(false);
  const px = SIZES[size];
  const rad = radius ?? Math.round(px * 0.22);
  const meta = inferCategory(sku, category);
  const showImg = !!imageUrl && !errored;
  const labelSize = Math.max(8, Math.round(px * 0.2));
  return (
    <div
      style={{
        position: "relative",
        width: px,
        height: px,
        borderRadius: rad,
        overflow: "visible",
        flexShrink: 0,
        background: showImg ? "var(--tcg-bg)" : meta.thumbBg,
        color: meta.thumbFg,
      }}
    >
      {showImg ? (
        <img
          src={imageUrl!}
          alt=""
          loading="lazy"
          onError={() => setErrored(true)}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
            borderRadius: rad,
          }}
        />
      ) : (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: labelSize,
            fontWeight: 800,
            borderRadius: rad,
          }}
        >
          {meta.thumbLabel}
        </div>
      )}
      {warnNoShopify && (
        <span
          title="Senza match Shopify"
          aria-label="senza match Shopify"
          style={{
            position: "absolute",
            top: -3,
            right: -3,
            width: 12,
            height: 12,
            borderRadius: "50%",
            background: "var(--tcg-warn)",
            border: "2px solid var(--tcg-card)",
          }}
        />
      )}
    </div>
  );
}
